export default function ContactCTA() {
  return (
    <section id="contact" className="py-24 px-6 bg-brand-text">
      <div className="max-w-6xl mx-auto grid md:grid-cols-2 gap-12 items-center">
        <div>
          <h2 className="text-3xl md:text-4xl font-700 tracking-tight text-white leading-snug mb-4">
            Start a conversation
          </h2>
          <p className="text-white/50 leading-relaxed">
            If your organization needs trusted technical guidance in robotics, physical AI, or international infrastructure work, we would be glad to talk.
          </p>
        </div>
        <div className="flex md:justify-end">
          <a href="mailto:contact@rgconsulting.com" className="inline-block bg-brand-blue text-white text-sm font-medium px-8 py-4 hover:bg-blue-600 transition-colors">
            Contact us
          </a>
        </div>
      </div>
    </section>
  );
}
